export default __webpack_public_path__ + "static/media/583.1c62b6d2.jpg";